export function fadeAnimate(element) {
    element.style.transition = 'opacity 150ms'
    element.style.opacity = '0.7'

    setTimeout(() => {
        element.style.opacity = '1'
    }, 150)
}
